const data = {
  testimonials:null
}

const set = (testimonials) => {
  data.testimonials = testimonials
}

const get = () => {
  return data.testimonials;
}

export default {set, get}